/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface EquipmentByIdLocationResponse { 
    facilityName: string;
    containerName: string;
    containerNumber: number;
    rackNumber: number;
    shelfNumber: number;
    placeNumber: number;
}

